module.exports = __webpack_public_path__ + "static/media/contact_01.d32dc190.jpg";